import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initializeApp } from "./lib/capacitor";

// Initialize Capacitor for mobile apps
if (typeof window !== 'undefined') {
  initializeApp().catch(console.error);
}

// Hide splash screen once app is mounted
const hideSplash = () => {
  const splash = document.getElementById("splash-screen");
  if (splash) {
    splash.style.transition = "opacity 0.3s ease-out";
    splash.style.opacity = "0";
    setTimeout(() => splash.remove(), 300);
  }
};

// Register service worker after page load to avoid blocking FCP
// Skip on native platforms (Capacitor handles caching differently)
const registerSW = async () => {
  // Don't register SW on native mobile apps
  const isNative = typeof window !== 'undefined' && 
    (window as any).Capacitor?.isNativePlatform?.();
  
  if (isNative) {
    console.log('Skipping service worker on native platform');
    return;
  }
  
  if ('serviceWorker' in navigator && import.meta.env.PROD) {
    try {
      await navigator.serviceWorker.register('/sw.js', { scope: '/' });
    } catch {
      // SW registration failed silently
    }
  }
};

const root = createRoot(document.getElementById("root")!);
root.render(<App />);

// Hide splash after a brief delay to ensure app is rendered
setTimeout(hideSplash, 100);

// Register SW after page fully loads (non-blocking)
if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    setTimeout(registerSW, 1000);
  });
}
